import {DocumentLoginService} from "./login/document-login-service";

import document from './document/link-document'
import documentMarkdown from './document/link-document-markdown'
import documentItemDemoInstance from './document/link-document-item-demo-instance'

import documentHome from './home/document-home'
import documentMenu from './home/document-menu'
// import documentMenuList from './home/document-menu-list'

import pageDocument from './page/document'
import pageDocumentDebug from './page/document-debug'
import pageNotComplete from './page/not-complete'
import pageNotFound from './page/not-found'
import pageDocAccessStatistics from './page/access-statistics'
import pageDocCreationStatistics from './page/creation-statistics'
import pageMyMenu from './page/my-menu'

const DocumentPage = {
	'document': pageDocument,
	'debug': pageDocumentDebug,
	'not-complete': pageNotComplete,
	'not-found': pageNotFound,
	'access': pageDocAccessStatistics,
	'creation': pageDocCreationStatistics,
	'my-menu': pageMyMenu
}

// 该部分注册到全局组件中
const DocComponents = {
	document,
	documentMarkdown,
	documentItemDemoInstance,

	documentHome,
	documentMenu,
	// documentMenuList,
	documentMenuList: pageMyMenu
}

export {DocComponents, DocumentPage, DocumentLoginService}
